<template>
    <div>
        <div class="content-header" ref="searchBoxRef">
            <el-select
                clearable
                filterable
                remote
                :remote-method="getMerchantList"
                v-model="queryForm.merchantId"
                class="input"
                placeholder="请选择品牌方名称"
                @focus="getMerchantList">
                <el-option
                    v-for="item in allMerchantList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.deviceName" class="input" clearable placeholder="请输入设备名称"></el-input>
            <el-input v-model="queryForm.storeShowName" class="input" clearable placeholder="请输入关联门店外显名称"></el-input>

            <el-button type="primary" class="search-btn" @click="handleSearch"
                >搜索</el-button
            >
        </div>

        <div class="table-list">
            <ETable v-loading="loading" :columns="columns" :data="tableData" style="width: 100%" :max-height="tableMaxheight" :header-cell-style="headerCellStyle" :cell-style="{}" border>
                <template #renewDuration>
                    <span>1年</span>
                </template>
                <template #status="{ row }">
                    <span :class="{ 'renew-status-2': row.status === 2 }">
                        {{ statusMap[row.status] || row.status }}
                    </span>
                </template>
                <template #operate="{ row }">
                    <el-button type="text" @click="handleOperate(row)">操作设备</el-button>
                </template>
            </ETable>
            <el-pagination style="margin-top: 20px" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="itemTotal"></el-pagination>
        </div>

        <el-dialog title="修改设备" :visible.sync="dialogVisible" width="460px" :before-close="dialogClose">
            <div class="edit-box">
                <el-form label-position="left" label-width="100px" :model="formData" ref="validateForm" :rules="rules">
                    <el-form-item label="设备名称:" prop="deviceName">
                        <el-input v-model="formData.deviceName" class="dialogInput" placeholder="请输入设备名称" maxlength="15" @input="handleDeviceNameInput">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogClose">取消</el-button>
                    <el-button type="primary" @click="dialogConfirm">保存</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    Watch,
    Mixins,
    Component,
    InjectReactive
} from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import GetMerchantByRemote from "@/mixins/getMerchantByRemote";

import ETable from "@/components/ETable.vue";

import { getQiaoPendingRenewList, updateQiaoPendingRenewDeviceName } from "@/api/qiaoDevice";

import deepCopy from "@/utils/deepCopy";

const initFormData = {
    deviceName: "",
};

@Component({
    components: {
        ETable
    }
})
export default class QiaoPendingRenew extends Mixins(loading, tablePagination, Resize, GetMerchantByRemote) {
    @InjectReactive() activeName;

    dialogVisible = false;
    currentRowId = 0;

    queryForm = {
        deviceName: "",
        storeShowName: "",
        merchantId: "",
    }

    formData = {
        deviceName: "",
    };

    rules = {
        deviceName: [{
            required: true,
            message: '请输入设备名称',
            trigger: 'blur'
        }]
    };

    statusMap = {
        1: "待充值",
        2: "失败",
        3: "成功",
    }

    columns = [
        {
            label: "设备名称",
            prop: "deviceName",
            minWidth: 120,
            align: "center"
        },
        {
            label: "创建任务时间",
            prop: "taskCreateTime",
            minWidth: 160,
            align: "center"
        },
        {
            label: "关联门店",
            prop: "storeName",
            minWidth: 140,
            align: "center"
        },
        {
            label: "关联外显名称",
            prop: "storeShowName",
            minWidth: 140,
            align: "center"
        },
        {
            label: "品牌方名称",
            prop: "merchantName",
            minWidth: 140,
            align: "center"
        },
        {
            label: "自动续费时长",
            width: 120,
            align: "center",
            slot: "renewDuration"
        },
        {
            label: "订单号",
            prop: "mallOrderNo",
            minWidth: 180,
            align: "center"
        },
        {
            label: "状态",
            prop: "status",
            width: 100,
            align: "center",
            slot: "status"
        },
        {
            label: "修改人",
            prop: "updateBy",
            width: 120,
            align: "center"
        },
        {
            label: "最后修改时间",
            prop: "updateTime",
            minWidth: 160,
            align: "center"
        },
        {
            label: "操作",
            prop: "operate",
            width: 100,
            align: "center",
            slot: "operate"
        },
    ]
    tableData = [];

    mounted() {
        this.windowResize();
    }

    handleSearch() {
        this.resetCurrent();
        this.getData();
    }

    getData() {
        this.showLoading();
        const params = {
            ...this.queryForm,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
        }
        getQiaoPendingRenewList(params).then(res => {
            this.itemTotal = res.data.total;
            this.tableData = res.data.list;
        }).catch(err => {}).finally(() => {
            this.hideLoading();
        })
    }

    handleOperate(row) {
        this.currentRowId = row.id;
        this.formData = {
            deviceName: row.deviceName || "",
        };
        this.dialogVisible = true;
    }

    dialogClose() {
        this.formData = deepCopy(initFormData);
        this.currentRowId = 0;
        this.$refs['validateForm'].resetFields();
        this.dialogVisible = false;
    }

    handleDeviceNameInput() {
        this.formData.deviceName = this.formData.deviceName.replace(/[^\x00-\x7F]/g, '');
    }

    dialogConfirm() {
        this.$refs['validateForm'].validate((valid) => {
            if (valid) {
                updateQiaoPendingRenewDeviceName({
                    id: this.currentRowId,
                    deviceName: this.formData.deviceName,
                }).then(() => {
                    this.$message.success('修改成功');
                    this.getData();
                    this.dialogClose();
                }).catch(() => {
                    this.getData();
                });
            }
        })
    }

    @Watch("activeName", { immediate: true })
    activeNameChange() {
        if (this.activeName != "third") return;
        this.getData();
    }
}
</script>

<style lang="scss" scoped src="../style.scss"></style>
<style lang="scss" scoped>
.content-header {
    border: none;
}
.search-btn { 
    margin-left: 12px;
}
.table-list {
  margin-top: 20px;
  background: #ffffff;
  border-radius: 8px;
  padding: 0 12px;
}
.renew-status-2 {
    color: red;
}

.el-icon-warning-outline {
    color: #666666;

    &:empty::after {
        content: "";
    }
}
</style>
